// extracted by mini-css-extract-plugin
export default {"page":"SalesPage_page__sG+XP","header":"SalesPage_header__rbv9z","list":"SalesPage_list__33kJf","person":"SalesPage_person__GqQS7","empty":"SalesPage_empty__doYbh"};